import { useMutation, useQueryClient } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

import { TRAY_DETAILS_QUERY_KEY } from './useFetchTrayDetails';

/**
 * This is to track the empty tray keys in react query cache.
 */
const MUTATE_EMPTY_TRAY = 'empty-tray-mutation-key';

interface IUseEmptyTrayMutationOptions {
  onSuccessCallback?: (isTrayEmpty: boolean) => void;
}

/**
 * React Query mutation function for empty a tray.
 */
export const useEmptyTrayMutation = ({
  onSuccessCallback,
}: IUseEmptyTrayMutationOptions) => {
  const queryClient = useQueryClient();
  const {
    data,
    error,
    isError,
    isPending,
    mutate: submitEmptyTray,
    reset,
  } = useMutation({
    mutationKey: [MUTATE_EMPTY_TRAY],
    networkMode: 'always',
    mutationFn: INV_MGMT_SERVICE_API.emptyTray,
    onSuccess: (resData) => {
      queryClient.invalidateQueries({
        queryKey: [TRAY_DETAILS_QUERY_KEY],
      });

      onSuccessCallback?.(resData.isTrayEmpty);
    },
  });

  return {
    data,
    error,
    isError,
    isPending,
    reset,
    submitEmptyTray,
  };
};
